import React, { useEffect, useState } from "react";
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AbstructVar } from "../../../components/general/general-component/abstruct-component/AbstructVar";
import { AbstructLang } from "../../../components/general/general-component/abstruct-component/AbstructLang";
import { Form } from "../../../components/general/general-component/abstruct-component/AbstructForm";
import { VariableExpenses } from "./VariableExpenses";
import {
  getPageListExpenses,
  postExpenses,
} from "../../../store/Actions/ActionExpenses";
import { useSelectorCustom } from "../../../components/general/general-component/abstruct-component/useSelectorCustom";
import moment from "moment";

function AddExpenses({
  statement_id,
  open,
  setOpen,
  isStatment,
  viewExpenses = "no",
}) {
  let { mode, dispatch, langLocal } = AbstructVar();

  const { translate } = AbstructLang();

  const images_type = [
    { value: "invoice_image", label: "Invoice Image" },
    { value: "delivery_receipt_image", label: "Delivery Receipt Image" },
  ];
  const { state, setStateCustom, setState, setLoad } = VariableExpenses();

  const { page_list_expenses, loadingPageListExpenses } = useSelectorCustom();

  const Submit = (e) => {
    e.preventDefault();
    dispatch(postExpenses(state, setLoad, viewExpenses));
  };

  useEffect(() => {
    dispatch(getPageListExpenses());
  }, []);

  useEffect(() => {
    if (!isStatment) {
      setState((prevState) => ({
        ...prevState,
        statement_id: statement_id,
      }));
    }
  }, [statement_id]);

  const [formFields, setFormFields] = useState();
  useEffect(() => {
    setStateCustom("invoice_image", "");
    setStateCustom("delivery_receipt_image", "");
    setFormFields([
      {
        name: "invoice_number",
        label: "invoice_number",
        type: "number",
        inputType: "text",
        iconType: "pencil",
      },
      {
        name: "image_type",
        label: "image_type",
        type: "text",
        inputType: "one_select",
        iconType: "statement",
        options: images_type,
      },
      state?.image_type === "invoice_image" && {
        name: "invoice_image",
        label: "invoice_image",
        type: "file",
        inputType: "file",
        iconType: "pencil",
        service_name: "ACCOUNTING",
      },
      state?.image_type === "delivery_receipt_image" && {
        name: "delivery_receipt_image",
        label: "delivery_receipt_image",
        type: "file",
        inputType: "file",
        iconType: "pencil",
        service_name: "ACCOUNTING",
      },
      {
        name: "date",
        label: "date",
        type: "date",
        inputType: "text",
        iconType: "pencil",
      },
      {
        name: "amount",
        label: "amount",
        type: "text",
        inputType: "text",
        iconType: "pencil",
      },
      isStatment && {
        name: "statement_id",
        label: "statements",
        type: "text",
        inputType: "one_select",
        iconType: "statement",
        options: page_list_expenses?.expense_statements?.map((type) => ({
          label: `${type?.number} | ${moment(type?.statement_date).format(
            "MM-DD-YYYY"
          )} | ${type?.project.name}`,
          value: type?.id,
        })),
      },
      {
        name: "description",
        label: "description",
        type: "text",
        inputType: "textArea",
        iconType: "pencil",
      },
      {
        name: "notes",
        label: "notes",
        type: "text",
        inputType: "textArea",
        iconType: "pencil",
      },
      {
        name: "revolving",
        label: "revolved",
        type: "text",
        inputType: "checkbox",
        iconType: "pencil",
      },
      state?.revolving === true && {
        name: "remaining_amount",
        label: "remaining_amount",
        type: "text",
        inputType: "text",
        iconType: "pencil",
      },
    ]);
  }, [
    state?.image_type,
    state?.revolving,
    page_list_expenses?.expense_statements,
  ]);
  return (
    <RModal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      center
      classNames={{
        modal: `popupR`,
      }}
      focusTrapped={false}
      overlayOpacity={0.5}
    >
      <div
        className={`div_popup ${mode === "dark" ? "darkPopUp" : "lightPopUp"}`}
      >
        <div
          className={`div_title_popup ${
            mode === "dark" ? "darktoppopup" : "lighttoppopup"
          }`}
        >
          <p
            className={`title_popup ${
              mode === "dark" ? "darktext" : "lighttext"
            }`}
          >
            {translate("add_expenses")}
          </p>
        </div>
        <Form
          langLocal={langLocal}
          fields={formFields}
          handleSubmit={Submit}
          state={state}
          setStateCustom={setStateCustom}
          buttonLabel="add"
        />
      </div>
    </RModal>
  );
}

export default AddExpenses;
